import React, { FC } from "react";
import "./RiskIndicator.scss";

type RiskIndicatorProps = {
  title: string;
  description: string;
  value: string;
  subValue: string;
  arrowColor?: string;
};
const RiskIndicator: FC<RiskIndicatorProps> = ({
  title,
  description,
  value,
  subValue,
  arrowColor
}: RiskIndicatorProps) => {
  return (
    <>
      <div className="risk-indicator">
        <div className="risk-indicator__value fw-300">
          {value}
          <span className={arrowColor}>
            <i className="icon-arrow-up-right"></i>
            <small className="text-7s">{subValue}%</small>
          </span>
        </div>
        <h3 className="risk-indicator__title">{title}</h3>
        <p>{description}</p>
      </div>
    </>
  );
};

export default RiskIndicator;
